import {cloneDeep, get} from "lodash";
import {
	CustomerGroupImportCustomersListCustomerDataObject, CustomerGroupImportCustomersListItemDataObject
} from "../dataObjects";
import {getString} from "Core/helpers/data";
import {ltrimString} from 'Core/helpers/string';
import {getDate, STANDARD_DATE_TIME_FORMAT} from 'Core/helpers/datetime';

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {CustomerGroupImportCustomersListItemDataObject}
 *
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new CustomerGroupImportCustomersListItemDataObject(
		getString(result, 'id'),
		inputCustomer(get(result, 'customer')),
		getString(result, 'importType'),
	);

	return result;
}

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {CustomerGroupImportCustomersListCustomerDataObject}
 */
export const inputCustomer = rawData => {
	let result = cloneDeep(rawData);
	const mobilePhoneNumber = getString(result, 'mobilePhoneNumber');

	result = new CustomerGroupImportCustomersListCustomerDataObject(
		getString(result, 'id'),
		getString(result, 'firstName'),
		getString(result, 'lastName'),
		getString(result, 'email'),
		(mobilePhoneNumber ? `+${ltrimString(mobilePhoneNumber, '+')}` : ''),
		getDate(get(result, 'dateOfBirth', null), STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S),
		getString(result, 'externalCrmId')
	);

	return result;
}